import Vue from 'vue';
import Vuex from 'vuex';

import actions from './action';
import mutations from './mutation';
import getters from './getter';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
    productDetail: {
        id: null,
        name: null,
        description: null,
        productImageSource: [],
        isConfigurable: false,
        productUrl: null,
        implementations: [],
        options: []
    },
    cartInfo: {
        datetime: null,
        items: []
    },
    langKeysSearching: {},
    baseLocaleLoaded: false
};

const store = new Vuex.Store({
    namespaced: true,
    state,
    actions,
    mutations,
    strict: debug,
    getters
});

store.subscribe((mutation, state) => {
    var ci = {
        cartInfo: {
            ...state.cartInfo
        }
    };
    window.localStorage.setItem('cartInfo', JSON.stringify(ci));
});

export default store;
